import { App as Application } from "../app/App";
import { addGlobalDebug } from "../utils/any";
// tslint:disable-next-line
import "./QuoteHack";

// tslint:disable-next-line:variable-name
export const App = new Application();

addGlobalDebug("App", App);
